"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mappingProcessor_1 = require("./mapping/mappingProcessor");
exports.MappingProcessor = mappingProcessor_1.MappingProcessor;
var metaProcessor_1 = require("./meta/metaProcessor");
exports.MetaProcessor = metaProcessor_1.MetaProcessor;
var schemaProcessor_1 = require("./schema/schemaProcessor");
exports.SchemaProcessor = schemaProcessor_1.SchemaProcessor;
//# sourceMappingURL=index.js.map